module.exports = __webpack_public_path__ + "fonts/Gilroy-500.9e12d60.otf";